export enum ApprovalState {
  TO_APPROVE = "TO_APPROVE",
  APPROVED = "APPROVED",
}
